module.exports = __webpack_public_path__ + "img/p18.8224934f.svg";